import React, { useCallback } from 'react'
import { Link, useParams } from 'react-router-dom'
import buttonStatusRestrictions from 'components/VirtualPortal/helpers/buttonStatusRestrictions'
import meetingPlatformTroubleshootingPopUp from 'components/VirtualPortal/helpers/meetingPlatformTroubleshootingPopUp'

const SessionIcons = ({ state, setState, isEventDay, virtualPortalPreRegistrationClosed }) => {
  const params = useParams()

  const desktopOrMobile = () => {
    const windowSize = window.innerWidth
    const desktopOrMobile = windowSize >= 767
    return desktopOrMobile
  }

  const joinMeeting = useCallback(() => {
    window.api.get(`/virtual_portal/join_url/${state.session.id}`).then((response) => {
      if (response && response.data && response.data.url) {
        meetingPlatformTroubleshootingPopUp(response.data.url, state.session, setState)
        // if desktop window was too be very, very small width, opening link with '_top' will open in the same tab
        window.open(response.data.url, desktopOrMobile() ? '_blank' : '_top')
        state.session.is_checked_in = true
        setState({
          session: state.session
        })
      } else {
        setState({
          errorModalIsOpen: true,
          errorStatus: 'Error',
          errorMessage: 'Sorry, something went wrong.'
        })
      }
    }).catch(() => {
      setState({
        errorModalIsOpen: true,
        errorStatus: 'Webex Error',
        errorMessage: 'Sorry, we are having trouble connecting you to the event.'
      })
    })
  },[state])

  const sessionEvalButton = useCallback(() => {
    const user = state.userDetails
    if (!state.session.is_checked_in || !state.meetingEnded || state.session.registration_status !== 'un_register' || ['registration_status_approved_sponsor', 'registration_status_approved_speaker'].includes(user.status) || state.session.session_type_key == 'session_type_one_to_one_meeting') {
      return
    }
    if (state.evaluationCompleted){
      return <button className='eblue-button feedback-given' disabled><i className='fa fa-check-circle'></i> Feedback</button>
    } else if (user.can_take_session_survey == true) {
      return <button className='eblue-button give-feedback' onClick={ () => setState({ isOpen: true }) }>Give Feedback</button>
    }
  },[state])

  const joinMeetingButton = useCallback(() => {
    if(state.meetingEnded || state.session.registration_status !== 'un_register' || !isEventDay || state.session.virtual_platform_name === null || buttonStatusRestrictions(state)) {
      return
    }
    if (state.meetingHasStarted && !state.meetingEnded) {
      return (<button onClick={joinMeeting} className='btn btn-primary'>Join Meeting</button>)
    } else {
      // TODO: can we put a tooltip here?
      return (<button className='btn btn-primary disabled'>Join Meeting</button>)
    }
  },[state, isEventDay, buttonStatusRestrictions])

  const p2psetup = useCallback(() => {
    if(state.session.session_type_key == 'session_type_one_to_one_meeting' && state.userDetails.status === 'registration_status_approved') {
      if(state.meetingHasStarted) {
        return
      }
      if(virtualPortalPreRegistrationClosed) {
        return
      }
      return <Link to={'/' + params.token + '/profile/wizard'} className="editp2plink">
        <button className="editp2p">
          { state.oneOnOneWizardIsComplete ? 'EDIT' : 'COMPLETE' } PEER-TO-PEER SETUP
        </button>
      </Link>
    }
  },[state, params])

  return(
    <div className='session-icons'>
      {sessionEvalButton()}
      {joinMeetingButton()}
      {p2psetup()}
    </div>
  )
}

export default SessionIcons